import { useEffect } from "react";

/** Tiny redirect to the standalone Investor Kit dataroom HTML. */
const KitInversorRedirect = () => {
  useEffect(() => {
    window.location.replace("/kit-inversor.html");
  }, []);
  return (
    <div style={{
      minHeight: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      background: "#0A0F1F",
      color: "#c9a227",
      fontFamily: "system-ui, sans-serif",
      fontSize: "14px",
      letterSpacing: "2px",
      textTransform: "uppercase",
    }}>
      Cargando…
    </div>
  );
};

export default KitInversorRedirect;
